import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledCareNeedsMultiSelectOption = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[950]};
    `
)

export const StyledCareNeedsMultiSelectCheckboxWrapper = styled.button(
    ({theme: {palette, spacing}}) => css`
        width: 100%;
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        cursor: pointer;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 6px;
        &:hover {
            background-color: ${palette.neutral[100]};
        }
    `
)

export const StyledCareNeedsMultiSelectCheckbox = styled(Checkbox)`
    background-color: transparent;
`

export const StyledCareNeedsChipsContainer = styled(Flexbox)`
    flex-wrap: wrap;
`

export const StyledCareNeedsChip = styled(Badge)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        font-weight: 400;
        display: flex;
        align-items: center;
    `
)

export const StyledCareNeedProvinceAcronym = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[500]};
    `
)
